import { ReportsProvider } from '@reports/presentation/contexts';
import { CancellationReportContent } from '@reports/presentation/components/specific/CancellationReport';
import { PageLayout } from '@reports/presentation/components/base/PageLayout';

/**
 * Cancellation Report Page
 *
 * Entry point for the Cancellation Report.
 * Infrastructure dependencies are managed by composition root (initialized in App bootstrap).
 * Each report page is isolated with its own state through ReportsProvider.
 */
export const CancellationReportPage = () => {
  return (
    <PageLayout>
      <ReportsProvider>
        <CancellationReportContent />
      </ReportsProvider>
    </PageLayout>
  );
};
